module.exports = __webpack_public_path__ + "img/close.cceb0b0.svg";